import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'
import { COURSE_FRAGMENT } from '@base/api/fragments/course'

export const LIST_COURSES = gql`
  ${SERVER_ERROR}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${COURSE_FRAGMENT}

  query clubListCourses(
    $filter: ListCoursesFilter!
    $sort: [ListCoursesSort!]!
    $offset: Int
    $limit: Int
    $startDate: DateTime
    $endDate: DateTime
  ) {
    listCourses(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
      ... on ListCoursesOutput {
        courses {
          ...Course
          teeTimes(
            filter: { startTimestamp: $startDate, endTimestamp: $endDate }
            sort: []
          ) {
            ... on ListTeeTimesOutput {
              teeTimes {
                id
                time
                availability
              }
            }
          }
        }
        count
      }
      ... on ListCoursesErrorOutput {
        errors {
          courseName
          numHoles
          startDate
          endDate
          availability
          addressGeom
          sort
          limit
          offset
        }
      }
      ...UnauthenticatedError
      ...UnauthorizedError
      ...ServerError
    }
  }
`
